module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_vtrusguard.1b8cb7cc6b39008851b5a69bf11fd385.png";